<template>
  <ul v-if="node">
    <li>
      <span @click="toggle" :style="{ cursor: showToggle ? 'pointer' : 'default' }">
        <v-progress-circular v-if="isLoading" small indeterminate size="19"></v-progress-circular>

        <v-icon v-else :class="{ transparentIcon: !hasChildren && !isTeacher }">{{
          isOpen ? 'mdi-folder-open-outline' : 'mdi-folder-outline'
        }}</v-icon>

        <span>
          {{ node.name }} <span style="color: grey; font-size: 15px;">{{ node.subName ? node.subName : '' }}</span>

          <span
            v-if="node.approvedFile !== undefined && node.notSeenFiles !== undefined && node.name !== 'PL4'"
            style="color: grey; font-size: 15px;"
          >
            ({{ `${node.approvedFile} tài liệu đã duyệt` }} / {{ `${node.notSeenFiles + node.approvedFile} tài liệu` }})
          </span>
          <span v-if="node.name === 'PL4'" style="color: grey; font-size: 15px;">
            ({{ `${pl4Totals.approved}  tài liệu đã duyệt` }} /
            {{ `${pl4Totals.approved + pl4Totals.notSeen}  tài liệu ` }})
          </span>
        </span>
      </span>

      <span
        v-for="child in node.children"
        :key="child.id"
        @click.stop="openDialog(child)"
        :style="{ cursor: showToggle ? 'pointer' : 'default' }"
        :class="{ 'primary--text': child.fetchedFromCategories }"
      >
        <TreeNode v-if="isOpen && hasChildren" :node="child" :parentPath="parentPath.concat(node)"></TreeNode>
      </span>

      <FullScreenDialog v-model="showDialog" :content="selectedItem"></FullScreenDialog>
    </li>
  </ul>
</template>

<script>
import FullScreenDialog from './FullScreenDialog.vue'
import { mapActions } from 'vuex'
export default {
  name: 'TreeNode',
  props: {
    node: { type: Object, default: null },
    parentPath: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isOpen: false,
      isLoading: false,
      showDialog: false,
      selectedItem: { catId: null, currId: null, subType: '', type: null, subjectGroupId: '' }
    }
  },
  computed: {
    isTeacher() {
      return this.node && this.node.name && !this.node.children
    },
    hasChildren() {
      return this.node && this.node.children && this.node.children.length > 0
    },
    showToggle() {
      return this.isTeacher || this.hasChildren || this.node.fetchedFromCategories
    },
    pl4Totals() {
      if (!this.node || this.node.name !== 'PL4') {
        return {
          approved: 0,
          notSeen: 0
        }
      }

      const totals = this.node.children.reduce(
        (acc, child) => {
          acc.approved += child.approvedFile || 0
          acc.notSeen += child.notSeenFiles || 0
          return acc
        },
        { approved: 0, notSeen: 0 }
      )

      return totals
    }
  },
  methods: {
    ...mapActions('teacherDoc', ['fetchTeachings', 'fetchTeachers', 'fetchTeacherCat']),
    toggle() {
      if (!this.node) return
      this.isOpen = !this.isOpen
      if (this.isTeacher && !this.hasChildren) {
        this.fetchCategories()
      }
    },
    async fetchCategories() {
      this.isLoading = true
      let params = {
        type: null,
        teacher: null,
        subjectGroup: null,
        academicLevel: null,
        class: null
      }

      this.parentPath.forEach(parent => {
        if (parent.type) {
          params.type = parent.type
          this.node.type = parent.type
        }
        if (parent.teacherId) params.teacher = parent.teacherId
        if (parent.subjectGroupId) params.subjectGroup = parent.subjectGroupId
        if (parent.class) params.class = parent.class
        if (parent.level) params.academicLevel = parent.level
      })

      if (this.node.level) {
        params.academicLevel = this.node.level
      } else if (this.node.class) {
        params.class = this.node.class
      }
      if (params.type === null && this.node.type) {
        params.type = this.node.type
      }
      if (params.teacher === null && this.node.teacherId) {
        params.teacher = this.node.teacherId
      }
      if (this.selectedItem.subType) {
        params.subType = this.selectedItem.subType
      }
      try {
        const data = await this.fetchTeacherCat({ ...params, isArchived: 'false' })
        if (params.subType) {
          const categories = data

            .map(item => {
              return {
                name: item.title,
                index: item.index,
                children: [],
                id: item.id,
                currId: params.teacher,
                subjectGroupId: item.subjectGroup ? item.subjectGroup.id : '',
                fetchedFromCategories: true,
                approvedFile: item.approvedFile,
                notSeenFiles: item.notSeenFiles,
                subType: item.subType,
                type: this.node.type
              }
            })
            .sort((a, b) => a.index - b.index)

          this.$set(this.node, 'children', categories)
        } else {
          const subCat = data
            .filter(item => item.subType === 'grade')
            .map(item => ({
              name: item.title,
              index: item.index,
              children: [],
              id: item.id,
              currId: params.teacher,
              subType: item.subType,
              fetchedFromCategories: true,
              approvedFile: item.approvedFile,
              notSeenFiles: item.notSeenFiles,
              type: this.node.type,
              subjectGroupId: item.subjectGroup ? item.subjectGroup.id : ''
            }))

          const categories = data
            .filter(item => item.subType !== 'grade' || item.title === 'PL4')
            .map(item => {
              const isPL4 = item.title === 'PL4'
              return {
                name: item.title,
                index: item.index,
                children: item.title === 'PL4' ? subCat : [],
                id: item.id,
                currId: params.teacher,
                fetchedFromCategories: !isPL4,
                approvedFile: isPL4 ? null : item.approvedFile,
                notSeenFiles: isPL4 ? null : item.notSeenFiles,
                type: this.node.type,
                subjectGroupId: item.subjectGroup ? item.subjectGroup.id : ''
              }
            })
            .sort((a, b) => a.index - b.index)

          this.$set(this.node, 'children', categories)
        }
      } catch (error) {
        console.error('Failed to fetch categories:', error)
      } finally {
        this.isLoading = false
      }
    },
    openDialog(childNode) {
      if (childNode.fetchedFromCategories) {
        this.selectedItem.catId = childNode.id
        this.selectedItem.currId = childNode.currId
        this.selectedItem.subType = childNode.subType ? childNode.subType : ''
        this.selectedItem.type = this.node.type
        this.selectedItem.subjectGroupId = childNode.subjectGroupId
        this.showDialog = true
      }
    },

    calculateTotals(node) {
      if (!node) return { approved: 0, notSeen: 0 }

      let totals = {
        approved: node.approvedFile || 0,
        notSeen: node.notSeenFiles || 0
      }

      if (node.children && node.children.length > 0) {
        for (let child of node.children) {
          let childTotals = this.calculateTotals(child)
          totals.approved += childTotals.approved
          totals.notSeen += childTotals.notSeen
        }
      }
      return totals
    },
    async refreshTreeNode() {
      try {
        if (this.node.name === 'PL4') {
          await this.fetchCategories()
          if (this.parentPath.length) {
            const parentNode = this.parentPath[this.parentPath.length - 1]
            let parentNodeTotals = this.calculateTotals(parentNode)
            parentNode.subName = `(${parentNodeTotals.approved} tài liệu đã duyệt / ${parentNodeTotals.approved +
              parentNodeTotals.notSeen} tài liệu)`
          }
        } else {
          await this.fetchCategories()
          let currentNodeTotals = this.calculateTotals(this.node)
          this.node.subName = `(${currentNodeTotals.approved} tài liệu đã duyệt / ${currentNodeTotals.approved +
            currentNodeTotals.notSeen} tài liệu)`
        }
      } catch (error) {
        console.error('Failed in refreshTreeNode:', error)
      }
    }
  },
  components: {
    TreeNode: () => import('./TreeNode.vue'),
    FullScreenDialog
  },
  watch: {
    showDialog(newVal, oldVal) {
      if (!newVal && oldVal) {
        this.refreshTreeNode()
      }
    }
  }
}
</script>

<style scoped>
ul {
  list-style-type: none;
  padding-left: 20px;
}

li {
  display: inline-block;
  margin: 5px 0;
}
.transparentIcon {
  opacity: 0;
}
</style>
